import { Show } from 'solid-js';
import { StyledProgressBarContainer, StyledProgressBarBackground, StyledProgressBar, StyledProgressBarText } from './course-card.styles';
import { Text } from '../../ui-components/text/text';

type ProgressBarProps = {
    inProgress: boolean;
    progress: number;
}

export const ProgressBar = (props: ProgressBarProps) => (
    <Show when={props.inProgress}>
        <StyledProgressBarContainer>
            <StyledProgressBarBackground>
                <StyledProgressBar progress={props.progress} />
            </StyledProgressBarBackground>

            <StyledProgressBarText>
                <Text fontSize='smaller' color='atosBlue1'>
                    {`${props.progress}%`}
                </Text>
            </StyledProgressBarText>
        </StyledProgressBarContainer>
    </Show>
);

